const selectors = {
    getEvents: ({ lifecycle } = {}) => lifecycle?.events,
}

export default selectors
